import { render } from "./SolutionPage4.vue?vue&type=template&id=2a9a814b&scoped=true"
import script from "./SolutionPage4.vue?vue&type=script&lang=js"
export * from "./SolutionPage4.vue?vue&type=script&lang=js"

import "./SolutionPage4.vue?vue&type=style&index=0&id=2a9a814b&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.2.2_@vue+compiler-sfc@3.3.4_vue@3.3.4_webpack@5.88.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a9a814b"]])

export default __exports__